"use strict";
/**
 * Legacy Polymarket adapter.
 *
 * The venue is frozen (REVIEW_FOR_DELETION.md §3) and off the menu — its pill
 * is `hidden` — but it still works, so this delegates rather than throwing.
 * A throwing stub would be a behaviour change inside a phase whose whole claim
 * is that there are none.
 *
 * Do not extend this. If legacy Polymarket ever needs new behaviour, the
 * question to answer first is whether it should still exist.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.polymarketAdapter = void 0;
const polymarketApi = __importStar(require("../polymarket-api"));
const polymarket_fetcher_1 = require("../markets/polymarket-fetcher");
const cache_1 = require("../markets/cache");
const polymarket_orderbook_1 = require("../polymarket-orderbook");
const orderbook_1 = require("../orderbook");
const polymarket_creation_1 = require("../orders/polymarket-creation");
exports.polymarketAdapter = {
    id: "polymarket",
    label: "Polymarket",
    orderErrorLabel: "Polymarket order",
    capabilities: {
        leagueSelector: "flat-list",
        sideLabels: "both",
        sellFullPosition: false,
        // Frozen: never offered as a fan-out target or a sport-mode venue.
        fanOutTarget: false,
        sportModes: false,
        fractionalQuantity: true,
        priceTicks: "uniform",
        orderbookIntervalMs: 500,
        pnlDetail: false,
        marketOrder: "id-length",
    },
    fetchEvents(query) {
        return (0, polymarket_fetcher_1.fetchPolymarketEvents)(query.category, query.tagSlug);
    },
    fetchEventMarkets(eventId) {
        return (0, polymarket_fetcher_1.fetchPolymarketEventMarkets)(eventId);
    },
    async fetchLeagues() {
        const sports = await polymarketApi.getSports();
        return sports.map((sport) => ({
            value: sport.series,
            label: sport.sport,
            sortKey: sport.sport.toLowerCase(),
            id: sport.id,
            // No `slug`: this venue has never carried one, and the legacy
            // polymarketSports entry it feeds must keep its exact shape.
        }));
    },
    cachedEvents() {
        return (0, cache_1.getPolymarketEventCache)().map(polymarketApi.polymarketEventToDisplayEvent);
    },
    startOrderbook(market, opts) {
        const tokenIds = market.clobTokenIds;
        if (!tokenIds || tokenIds.length === 0) {
            opts.onError(new Error("Polymarket orderbook requires clobTokenIds"));
            return () => { };
        }
        return (0, polymarket_orderbook_1.startPolymarketOrderbookPolling)(tokenIds, (response) => {
            const converted = (0, orderbook_1.convertPolymarketToKalshiFormat)(response);
            if (!converted) {
                console.warn("Failed to convert Polymarket orderbook");
                opts.onUpdate(null);
                return;
            }
            opts.onUpdate((0, orderbook_1.parseOrderbook)(converted));
        }, opts.intervalMs ?? this.capabilities.orderbookIntervalMs);
    },
    buildOrderRequest(ctx) {
        return (0, polymarket_creation_1.createPolymarketOrderRequest)(ctx.marketId, ctx.side, ctx.action);
    },
    async placeOrder(request) {
        const response = await polymarketApi.placeOrder(request);
        const main = response.data.orders.find((o) => o.type === "main");
        if (!main) {
            throw new Error("No main order found in response");
        }
        const quantity = main.calculated_shares || main.size || 0;
        const order = {
            order_id: main.order?.orderId || `poly-${Date.now()}`,
            market_id: main.token_id,
            side: "yes",
            quantity,
            // Legacy Polymarket does not return a fill price immediately.
            fill_price: 0,
            status: "pending",
            created_at: new Date().toISOString(),
        };
        return {
            // This venue's only signal is its success flag — it reports no fill
            // at placement time.
            succeeded: response.success,
            // null, not 0: "cannot report a fill" is different from "missed",
            // and it is what suppresses the badge this venue has never shown.
            filledQty: null,
            statusForState: null,
            order,
            raw: response,
        };
    },
};
